const customStepsCatalog = {
  florida_license: {
    '/my-agency/edit/florida-license': {
      next: '/my-agency',
      back: '/my-agency/edit/address',
      current: '/my-agency/edit/florida-license',
    },
    '/my-agency/compliance/florida-license': {
      next: '/my-agency/compliance/business-details',
      back: '/my-agency/compliance/address',
      menu: 'Agency Information',
      current: '/my-agency/compliance/florida-license',
      progressLabel: 'Agency Information',
    },
  },
};

const steps = {
  '/my-agency/agents/new': { next: '/my-agency/agents' },
  '/my-agency/agents/[0-9]+/edit': { next: '/my-agency/agents' },
  '/my-agency/edit': {
    next: '/my-agency/edit/address',
    back: '/my-agency',
    current: '/my-agency/edit',
  },
  '/my-agency/edit/address': {
    next: '/my-agency',
    back: '/my-agency/edit',
    current: '/my-agency/edit/address',
  },
  '/my-agency/edit/errors-omissions': {
    next: '/my-agency',
    back: '/my-agency',
    current: '/my-agency/edit/errors-omissions',
  },
  '/my-agency/edit/agency-license': { next: '/my-agency', back: '/my-agency' },

  '/my-agency/compliance': {
    isHiddenNavigation: true,
  },
  '/my-agency/compliance/agency-info': {
    next: '/my-agency/compliance/address',
    back: '/my-agency/compliance',
    menu: 'Agency Information',
    current: '/my-agency/compliance/agency-info',
    progressLabel: 'Agency Information',
  },
  '/my-agency/compliance/address': {
    next: '/my-agency/compliance/business-details',
    back: '/my-agency/compliance/agency-info',
    menu: 'Agency Information',
    current: '/my-agency/compliance/address',
    progressLabel: 'Agency Information',
  },
  '/my-agency/compliance/business-details': {
    next: '/my-agency/compliance/agency-license',
    back: '/my-agency/compliance/address',
    menu: 'Business Details',
    current: '/my-agency/compliance/business-details',
    progressLabel: 'Compliance: Agency License and Errors & Omissions Coverage',
  },
  '/my-agency/compliance/agency-license': {
    next: '/my-agency/compliance/errors-omissions',
    back: '/my-agency/compliance/business-details',
    menu: 'Business Details',
    current: '/my-agency/compliance/agency-license',
    progressLabel: 'Compliance: Agency License and Errors & Omissions Coverage',
  },
  '/my-agency/compliance/errors-omissions': {
    next: '/my-agency/compliance/w9',
    back: '/my-agency/compliance/agency-license',
    menu: 'E&O Coverage',
    current: '/my-agency/compliance/errors-omissions',
    progressLabel: 'Compliance: Agency License and Errors & Omissions Coverage',
  },
  '/my-agency/compliance/w9': {
    next: '/my-agency/compliance/agreement',
    back: '/my-agency/compliance/errors-omissions',
    menu: 'W-9 Form',
    current: '/my-agency/compliance/w9',
    progressLabel: 'W-9 Form',
    isHiddenNavigation: true,
  },
  '/my-agency/compliance/agreement': {
    next: '/my-agency/compliance/bank-information',
    back: '/my-agency/compliance/w9',
    menu: 'Sign Agreement',
    current: '/my-agency/compliance/agreement',
    progressLabel: 'Sign Agreement',
    isHiddenNavigation: true,
  },
  '/my-agency/compliance/bank-information': {
    next: '/my-agency',
    back: '/my-agency/compliance/agreement',
    menu: 'Bank Information',
    current: '/my-agency/compliance/bank-information',
    progressLabel: 'Bank information',
    isHiddenNavigation: true,
  },
};

export default { steps, customStepsCatalog };
